import React from 'react';
import PropTypes from 'prop-types';
import useDialogConfig from '@hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../csv_download';
import useNetwork from '@/hooks/useNetwork';

export default function Launcher(props) {
  const config = useDialogConfig();

  const modelName = config.params.modelName;
  const query = JSON.parse(config.params.query);

  // Force the network onto the $where object so the server doesn't reject the call. See to do note in
  // steward-api/api-steward/services/csvUser/find/permissionChecker.js
  const network = useNetwork();
  if (network && network.id && !query?.where?.eager?.$where?.networkId) {
    if (!query.where) query.where = {};
    if (!query.where.eager) query.where.eager = {};
    query.where.eager.meta = {networkId: network.id};
  }

  return (
    <Dialog
      modelName={modelName}
      query={query}
      onClose={props.onClose}
    />
  );
};

Launcher.propTypes = {
  onClose: PropTypes.func
};
